<div class="dlg-hdr">
  <div class="dlg-hdr__title">
    <div class="dlg-hdr__icon-wrap"><mat-icon>payment</mat-icon></div>
    <div>
      <span>Contabilizar {{ isContribution === true ? 'Aportación' : 'Devolución' }}</span>
    </div>
  </div>
  <button mat-icon-button class="dlg-hdr__close" (click)="closeDialog()" aria-label="Cerrar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="dlg-body">

  <ng-container *ngIf="ready == false">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
  </ng-container>

  <ng-container *ngIf="ready">
    <div class="row mb-3" *ngIf="depositSaved === false">

      <div class="col-4">
        <mat-label>Asignar la fecha</mat-label>
        <mat-form-field class="w-100 mt-2 mb-2">
          <mat-label>Fecha de pago</mat-label>
          <input matInput [matDatepicker]="Paided" placeholder="" name="transactionModel.date" required
            [(ngModel)]="transactionModel.date" />
          <mat-datepicker-toggle matSuffix [for]="Paided"></mat-datepicker-toggle>
          <mat-datepicker #Paided></mat-datepicker>
          <mat-error *ngIf="invalidDate">Campo requerido</mat-error>
        </mat-form-field>
      </div>
      <div class="col-4">
        <app-input inputType="text" placeholder="Descripción" [isRequired]="true"
          [(ngModel)]="transactionModel.description"></app-input>
      </div>

      <div class="col-4">
        <mat-label>Cuenta contable</mat-label>
        <mat-form-field class="w-100 mt-2 mb-2">
          <mat-select [(ngModel)]="transactionModel.accountingModelsId" required>
            <mat-option
              [value]="partnerSelected.accountingModels118Id">{{partnerSelected.accountingModels118}}</mat-option>
            <mat-option
              [value]="partnerSelected.accountingModels551Id">{{partnerSelected.accountingModels551}}</mat-option>
          </mat-select>
          <mat-error *ngIf="invalidAccountNumber">Campo requerido</mat-error>
        </mat-form-field>
      </div>
      <div class="col-4">
        <mat-label>Asignar cantidad</mat-label>
        <mat-form-field class="w-100 mb-2">
          <input type="number" min="0" matInput placeholder="Cantidad" [(ngModel)]="transactionModel.amount"
            value="transactionModel.amount" class="" required>
          <mat-error *ngIf="invalidAmount">Campo requerido</mat-error>
        </mat-form-field>
      </div>
      <div class="col-4">
        <app-select name="transactionModel.typePay" [(ngModel)]="transactionModel.typePay"
          [config]="{ label: 'Tipo de pago', placeholder: 'Seleccionar', required: true, loadOptions: () => typePayOptions }">
        </app-select>
      </div>

      <div class="col-4" *ngIf="transactionModel.typePay === 'Efectivo'">
        <app-select name="transactionModel.efectivoId" [(ngModel)]="transactionModel.efectivoId"
          [config]="{ label: 'Caja/efectivo', required: true, loadOptions: () => efectivoOptions }">
        </app-select>
      </div>
      <div class="col-4" *ngIf="transactionModel.typePay === 'Transferencia bancaria'">
        <app-select name="transactionModel.bankAccountsUid" [(ngModel)]="transactionModel.bankAccountsUid"
          [config]="{ label: 'Cuentas bancarias', placeholder: 'Seleccionar', required: true, loadOptions: () => bankAccountOptions }">
        </app-select>
      </div>

      <div class="col-4" *ngIf="transactionModel.typePay === 'Transferencia bancaria'">
        <mat-label>Comisión</mat-label>
        <mat-form-field class="w-100 mb-2">
          <input matInput placeholder="Comisión" type="text" [(ngModel)]="transactionModel.commissions"
            value="transactionModel.commissions" numberDecimalsDirective>
        </mat-form-field>
      </div>
    </div>

    <div class="row" *ngIf="depositSaved === true">
      <div class="col-12">
        <div>Depósito {{ isEditMode === true ? 'actualizado': 'añadido' }} correctamente</div>
        <button mat-stroked-button class="mt-3" (click)="closeDialog()">
          <mat-icon>close</mat-icon>
          Cerrar
        </button>
      </div>
    </div>

    <div class="row" *ngIf="list == true" style="max-height: 40vh;">
      <div>
        <div class="fc-black mt-3">Listado de pagos</div>
      </div>

      <app-table [columns]="headerTable" [dataSource]="dataSource" [hasSelect]="false" [hasButton]="true"
        [actionsTemplate]="actionsButtons">
      </app-table>

      <ng-template #actionsButtons let-uid="uid">
        <ng-container *ngFor="let row of (dataSource | filter : uid : 'uid'); trackBy: trackByIndex">
          <ul class="custom-class">
            <li (click)="edit(uid)">
              <a>
                <mat-icon>create</mat-icon> Editar
              </a>
            </li>
            <li (click)="delete(uid)">
              <a>
                <mat-icon>warning</mat-icon> Borrar
              </a>
            </li>
          </ul>
        </ng-container>
      </ng-template>
    </div>

  </ng-container>

</mat-dialog-content>

<mat-dialog-actions align="end" class="dlg-actions" *ngIf="ready && depositSaved === false">
  <button mat-stroked-button (click)="closeDialog()">Cerrar</button>
  <button mat-flat-button class="dlg-btn-save" (click)="pay()">
    <mat-icon>save</mat-icon>
    {{ isEditMode === true ? 'Actualizar pago' : 'Pagar'}}
  </button>
</mat-dialog-actions>
